import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgAddUser = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9.5 5.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5M5.75 8a3.75 3.75 0 1 1 7.5 0 3.75 3.75 0 0 1-7.5 0m12.75-.25a.75.75 0 0 1 .75.75v1.75H21a.75.75 0 0 1 0 1.5h-1.75v1.75a.75.75 0 0 1-1.5 0v-1.75H16a.75.75 0 1 1 0-1.5h1.75V8.5a.75.75 0 0 1 .75-.75m-9 6.5c-3.814 0-5.35 2.43-5.947 3.894l-.008.026v.007c0 .001 0 .007.008.016.015.02.06.057.145.057h11.604c.085 0 .13-.037.145-.057q.01-.015.008-.016v-.007l-.008-.026c-.596-1.464-2.133-3.894-5.947-3.894m-7.336 3.327C2.88 15.818 4.83 12.75 9.5 12.75s6.619 3.068 7.336 4.827c.475 1.165-.483 2.173-1.534 2.173H3.698c-1.051 0-2.01-1.008-1.534-2.173"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgAddUser;
